<template>
    <v-footer
      fixed
      padless
      height="45"
      light
      class="grey lighten-3 footer_app"
    >
    <!-- <v-btn icon v-if="!hideRefresh" @click="reloadPage()">
      <v-icon>refresh</v-icon>
    </v-btn> -->
    <slot name="left"></slot>
    <v-spacer v-if="!hideBackPage"></v-spacer>
    <span v-if="!hideTitle">
       <slot name="title"></slot>
    </span>

    <v-spacer v-if="!hideTitle"></v-spacer>
    <slot name="right"></slot>

    </v-footer>
</template>
<script>
export default {
   props: {
      hideRefresh: {
        type: Boolean
      },
      hideBackPage: {
        type: Boolean
      },
      hideTitle: {
        type: Boolean
      }
    },
    methods : {
      reloadPage(){
        this.$router.go();
      }
    }
}
</script>
<style scoped>
.footer_app{
  padding-right:10px;
  padding-left:10px;
}
</style>

